module.exports = __webpack_public_path__ + "static/media/X.71f33591.svg";